// Globally prevents browser autofill and password manager extensions from
// populating inputs / textareas across the entire app.
//
// Strategy:
//  - Sets autocomplete="off" (standard HTML, respected by most browsers/extensions)
//  - Sets data-lpignore="true" (LastPass)
//  - Sets data-1p-ignore (1Password)
//  - Sets data-form-type="other" (Dashlane)
//  - Sets data-bwignore="true" (Bitwarden)
//
// A MutationObserver watches for any new inputs rendered by React so dynamic
// components are covered without touching individual JSX files.

const AUTOFILL_ATTRS = {
  autocomplete: 'off',
  'data-lpignore': 'true',
  'data-1p-ignore': '',
  'data-form-type': 'other',
  'data-bwignore': 'true',
};

const SKIP_TYPES = new Set(['submit', 'button', 'reset', 'image', 'file', 'checkbox', 'radio', 'hidden', 'range', 'color']);

function applyToElement(el) {
  if (el.tagName === 'INPUT' && SKIP_TYPES.has((el.type || '').toLowerCase())) return;
  Object.entries(AUTOFILL_ATTRS).forEach(([attr, val]) => {
    if (!el.hasAttribute(attr)) {
      el.setAttribute(attr, val);
    }
  });
}

function applyToAll(root) {
  root.querySelectorAll('input, textarea').forEach(applyToElement);
}

export function initDisableAutofill() {
  applyToAll(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA') {
          applyToElement(node);
        } else {
          applyToAll(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
